module.exports = __webpack_public_path__ + "static/media/icono_phone_white.b1251325.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icono_phone_white.png
// module id = 882
// module chunks = 0